var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNoDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.363,
    height: 186.912,
    viewBox: "0 0 249.363 186.912",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00AABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AABE"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create_a_dashboard",
    transform: "translate(-941.882 -70.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_37",
    "data-name": "Subtraction 37",
    d: "M-12736,24097.3c-.354,0-.69-.014-1-.037l-210.288-14.744a13.925,13.925,0,0,1-9.6-4.789,13.934,13.934,0,0,1-3.4-10.166l10.046-143.143a13.949,13.949,0,0,1,4.438-9.283,13.93,13.93,0,0,1,9.514-3.75c.343,0,.691.021,1,.037l210.288,14.75a13.915,13.915,0,0,1,9.59,4.785,13.926,13.926,0,0,1,3.405,10.172l-10.038,143.141a13.979,13.979,0,0,1-4.445,9.283A13.923,13.923,0,0,1-12736,24097.3Zm-194.383-92.668a12.017,12.017,0,0,0-11.96,11.162l-2.754,39.336a11.923,11.923,0,0,0,2.914,8.713,11.908,11.908,0,0,0,8.22,4.094l185.632,12.98c.285.021.556.029.853.029a12.037,12.037,0,0,0,11.957-11.164l2.751-39.328a11.916,11.916,0,0,0-2.915-8.713,11.938,11.938,0,0,0-8.219-4.1l-185.632-12.982h-.057a4.13,4.13,0,0,1-.707.041Zm-.821-38.791a8.019,8.019,0,0,0-7.972,7.439l-.575,8.219a7.937,7.937,0,0,0,1.941,5.8,7.961,7.961,0,0,0,5.479,2.734l100.415,7.021c.156.01.362.018.568.018a8.019,8.019,0,0,0,7.971-7.437l.574-8.219a8.009,8.009,0,0,0-7.42-8.537l-100.415-7.023a2.549,2.549,0,0,1-.562.039Z",
    transform: "translate(13902.712 -23840.055)",
    fill: "rgba(159,168,191,0.13)",
    stroke: "rgba(124,141,168,0.2)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46351",
    "data-name": "Group 46351",
    fill: "#00AABE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66623",
    "data-name": "Path 66623",
    d: "M1122.3,133.46l18.35,8.347a20.544,20.544,0,0,0-3.2-21.6Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66624",
    "data-name": "Path 66624",
    d: "M1122.39,132.486,1137,119.7a20.658,20.658,0,0,0-8.645-5.661l-2.439,7.541Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66625",
    "data-name": "Path 66625",
    d: "M1123.36,113.015l-1.16,17.84,5.508-17.016a20.759,20.759,0,0,0-4.348-.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66626",
    "data-name": "Path 66626",
    d: "M1121.36,133.334l1.318-20.362a20.658,20.658,0,0,0-21.646,19.247,20.435,20.435,0,0,0,2,10.246Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66627",
    "data-name": "Path 66627",
    d: "M1120.35,154.112a20.708,20.708,0,0,0,20.013-11.689l-18.669-8.5-18.365,9.147A20.685,20.685,0,0,0,1120.35,154.112Z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46372",
    "data-name": "Group 46372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Group_46355",
    "data-name": "Group 46355",
    d: "M1150.77,118.482l2.151.139a.625.625,0,0,1,.584.664l-.137,2.138a.626.626,0,0,1-.665.584l-2.152-.139a.626.626,0,0,1-.584-.664l.138-2.138a.626.626,0,0,1,.665-.584Zm15.117,2.215-10.253-.66a.392.392,0,0,1,.05-.783l10.253.665a.39.39,0,1,1-.051.778Zm-3.237,1.494-7.125-.459a.392.392,0,0,1,.05-.783l7.125.463a.391.391,0,1,1-.014.782h-.037Z",
    fill: "#9fa4ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Group_46359",
    "data-name": "Group 46359",
    d: "M1150.28,126.072l2.152.139a.627.627,0,0,1,.585.665l-.139,2.139a.625.625,0,0,1-.665.584l-2.152-.139a.627.627,0,0,1-.585-.665l.139-2.139a.626.626,0,0,1,.665-.584Zm15.118,2.215-10.253-.66a.392.392,0,0,1,.049-.783l10.253.665a.39.39,0,0,1-.045.779h0Zm-3.239,1.494-7.125-.459a.392.392,0,0,1,.05-.783l7.125.463a.391.391,0,0,1-.01.782h-.041Z",
    fill: "#b4b8bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Group_46363",
    "data-name": "Group 46363",
    d: "M1149.79,133.663l2.152.138a.627.627,0,0,1,.584.665l-.138,2.137a.627.627,0,0,1-.665.585l-2.151-.139a.625.625,0,0,1-.584-.665l.138-2.137a.624.624,0,0,1,.664-.584Zm15.117,2.215-10.252-.66a.392.392,0,1,1,.05-.783l10.253.665a.39.39,0,1,1-.052.778Zm-3.238,1.494-7.124-.459a.392.392,0,1,1,.05-.783l7.124.463a.391.391,0,1,1-.014.781h-.037Z",
    fill: "#9fa4ac",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Group_46367",
    "data-name": "Group 46367",
    d: "M1149.29,141.253l2.153.139a.626.626,0,0,1,.584.665l-.138,2.139a.627.627,0,0,1-.666.584l-2.152-.139a.626.626,0,0,1-.584-.665l.138-2.139a.625.625,0,0,1,.665-.584Zm15.117,2.215-10.253-.66a.392.392,0,1,1,.05-.783l10.253.665a.39.39,0,1,1-.051.778Zm-3.238,1.494-7.124-.459a.392.392,0,0,1,.05-.783l7.124.462a.391.391,0,1,1-.014.782h-.037Z",
    fill: "#9fa4ac",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Group_46371",
    "data-name": "Group 46371",
    d: "M1148.8,148.844l2.152.139a.626.626,0,0,1,.585.665l-.139,2.139a.626.626,0,0,1-.665.584l-2.152-.139a.628.628,0,0,1-.585-.666l.139-2.138a.625.625,0,0,1,.665-.584Zm15.117,2.215-10.253-.66a.392.392,0,1,1,.05-.783l10.253.664a.39.39,0,1,1-.051.779Zm-3.237,1.494-7.126-.459a.392.392,0,0,1,.05-.783l7.125.462a.391.391,0,0,1-.05.78Z",
    fill: "#9fa4ac",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19609",
    "data-name": "Rectangle 19609",
    width: 23.892,
    height: 116.682,
    rx: 8.004,
    transform: "rotate(-85.988 542.682 -462.455)",
    fill: "#9fa4ac",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46457",
    "data-name": "Group 46457",
    fill: "#9fa4ac"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66660",
    "data-name": "Path 66660",
    d: "M992.6,142.155l76.852,5.374a1.6,1.6,0,0,1,1.482,1.7h0a1.6,1.6,0,0,1-1.7,1.482l-76.852-5.374a1.6,1.6,0,0,1-1.482-1.705h0a1.6,1.6,0,0,1,1.7-1.477Zm1.1-7.937,33.216,2.323a1.6,1.6,0,0,1,1.489,1.711h0a1.6,1.6,0,0,1-1.712,1.488l-33.217-2.323a1.6,1.6,0,0,1-1.488-1.711h0a1.6,1.6,0,0,1,1.712-1.488Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66661",
    "data-name": "Path 66661",
    d: "M984.688,135.526a1.936,1.936,0,0,0-3.823.2,2,2,0,0,0,.477,1.474c.024.023.053.039.077.061l-1.471,1.964h0a1.5,1.5,0,0,0-1.342.1c-.01.007-.018.017-.028.025-.149-.117-.3-.237-.448-.352-.256-.2-.5-.409-.77-.59h0l-.1-.079c.024-.07.06-.136.078-.208a3.017,3.017,0,0,0,.012-.538,1.906,1.906,0,0,0-3.286-1.113,1.881,1.881,0,0,0-.217,2.316c.02.029.049.051.07.079l-1.448,1.48h0c-.029-.011-.058-.02-.086-.032a1.343,1.343,0,0,0-.137-.052,1.438,1.438,0,0,0-1.817.918c-.013.031-.01.078-.053.1l-.035.5c.047.053.037.121.053.184a1.435,1.435,0,0,0,.937,1.022c.039.015.089.013.112.057l.48.034c.046-.041.107-.028.159-.04a1.417,1.417,0,0,0,1.073-.928,1.432,1.432,0,0,0-.116-1.211,1.7,1.7,0,0,0-.318-.355,1.666,1.666,0,0,1,.319.351c.194-.2.388-.393.581-.591l.883-.906c.043.027.079.062.124.086a2.165,2.165,0,0,0,.912.179,2.034,2.034,0,0,0,1.316-.6c.009-.01.014-.023.023-.034l.41.315h0l.771.611-.018.048a1.438,1.438,0,1,0,2.515-.277h0l1.252-1.651c.094-.126.186-.252.279-.379.051.023.1.055.151.074a.793.793,0,0,0,.1.013,1.928,1.928,0,0,0,2.289-1.271c.015-.045.007-.109.069-.132l.044-.636C984.686,135.677,984.7,135.6,984.688,135.526Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46376",
    "data-name": "Group 46376",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66662",
    "data-name": "Path 66662",
    d: "M1168.22,216.185l-.958,13.632a12.01,12.01,0,0,1-12.815,11.13L968.807,227.9a11.954,11.954,0,0,1-7.964-3.815,12.24,12.24,0,0,1-1.521-2.054,10.03,10.03,0,0,1-.541-1.026c3.124-2.49,8.559-6.23,12.676-5.921,7.246.538,8.829,4.473,15.275,4.953s12.309-14.806,18.145-14.381c3.158.239,4.146,2.569,5.847,4.645a8.291,8.291,0,0,0,6.2,3.248,1.929,1.929,0,0,0,.239.022c7.925.584,12.936-26.19,23.829-25.388,2.438.183,4.332,1.921,5.885,4.885a49.416,49.416,0,0,1,3.858,11.947c2.812,12.6,7.231,13.838,12.288,14.215,5.326.39,8.074-5.794,11.151-10.816,1.666-2.7,3.418-5.058,5.715-5.877a5.136,5.136,0,0,1,2.193-.3c5.287.389,7.938,9.875,12.93,17.162,2.94,4.307,6.727,7.853,12.354,8.265,5.116.378,8.4-1.051,10.889-3.1,4.868-3.984,6.687-10.288,13.212-9.807,3.858.286,5.482,3.1,7.117,5.747v.01c1.428,2.314,2.868,4.5,5.846,4.725,3.5.253,6.056-4.9,8.839-9.518,2.276-3.8,4.708-7.236,7.926-7,3.158.23,5.326,3.68,6.541,6.342.059.12.108.231.157.341C1168,215.663,1168.11,215.924,1168.22,216.185Z",
    fill: "#00AABE",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66663",
    "data-name": "Path 66663",
    d: "M1170.02,190.461v.03l-1.639,23.446-.161,2.248-.958,13.632a12.01,12.01,0,0,1-12.815,11.13L968.807,227.9a11.954,11.954,0,0,1-7.964-3.815c3.086-.681,5.551-2.208,7.882-3.427a11.606,11.606,0,0,1,6.177-1.742c4.947.336,8.052,3.016,12.233,4.025a12.633,12.633,0,0,0,2.266.361c1.619.115,3.419-.948,5.284-2.471,4.4-3.579,9.261-9.754,13.429-9.465a12.155,12.155,0,0,1,2.735.516c2.333.732,4,2.078,6.191,3.118a14.8,14.8,0,0,0,5.527,1.442c6.236.428,16.454-19.637,24.31-23.374a5.232,5.232,0,0,1,2.6-.585,6.089,6.089,0,0,1,3.694,1.694c5.1,4.568,7.284,16.809,14.009,17.272,2.759.186,4.972-1.174,6.989-3.035,1.977-1.811,3.759-4.1,5.715-5.877,1.947-1.8,4.06-3.1,6.678-2.917,7.915.544,11.236,13.3,20.4,13.931s17.114-23.9,26.628-23.252,13.152,12.654,21.417,13.221C1161.66,203.973,1167.42,195.167,1170.02,190.461Z",
    fill: "#00AABE",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66664",
    "data-name": "Path 66664",
    d: "M1168.38,213.937l-.161,2.248-.958,13.632a12.01,12.01,0,0,1-12.815,11.13L968.807,227.9a11.954,11.954,0,0,1-7.964-3.815,12.24,12.24,0,0,1-1.521-2.054,10.618,10.618,0,0,1,6.58-2.139,7.269,7.269,0,0,1,2.823.766c2.817,1.417,4.27,4.271,9.867,4.683,3.677.274,5.89-1.1,8.543-2.4a18.257,18.257,0,0,1,7.55-2.11,22.05,22.05,0,0,1,2.909.037c10.194.756,10.7,7.771,21.231,8.549s12.024-7.787,19.5-7.237,7.325,4.878,11.572,5.188,6.18-6.433,11.417-6.044,10.029,10.865,15.915,11.3c4.147.309,10.748-8.32,17.784-13.224,2.98-2.073,6.033-3.484,9.011-3.256,6.156.447,10.075,4.9,14.232,8.423,2.609,2.225,5.322,4.07,8.74,4.322,4.877.366,8.19-4.263,11.579-8.372h.01v-.01c2.761-3.344,5.559-6.338,9.287-6.063a15.224,15.224,0,0,1,5.388,1.28h.01c3.306,1.531,4.354,3.871,8.222,4.157,2.668.2,4.863-2.484,6.245-4.811C1167.98,214.683,1168.18,214.295,1168.38,213.937Z",
    opacity: 0.4,
    fill: "url(#linear-gradient)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNoDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_no_dashboard.9ff24c8c24e1cb7fed32a12f38d8a94b.svg";